import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import * as DeviceStoreSelectors from './device.selector';
import { Device } from '@era/locations-sdk';
import { LocationSubset } from './location-subset';

export function getDevicesFilteredOnSubset(
  deviceStore: Store<Device>,
  locationSubset: LocationSubset
): Observable<Device[]> {
  switch (locationSubset) {
    case LocationSubset.All:
      return deviceStore.pipe(select(DeviceStoreSelectors.selectCurrentLocationDevices));
    case LocationSubset.Assigned:
      return deviceStore.pipe(select(DeviceStoreSelectors.selectCurrentLocationAssignedDevices));
    case LocationSubset.Spare:
      return deviceStore.pipe(select(DeviceStoreSelectors.selectCurrentLocationSpareDevices));
    case LocationSubset.Swapped:
      return deviceStore.pipe(select(DeviceStoreSelectors.selectCurrentLocationSwappedDevices));
    case LocationSubset.Housekeeping:
      return deviceStore.pipe(select(DeviceStoreSelectors.selectCurrentLocationHousekeepingDevices));
    case LocationSubset.Staff:
      return deviceStore.pipe(select(DeviceStoreSelectors.selectCurrentLocationStaffDevices));
    case LocationSubset.FrontDesk:
      return deviceStore.pipe(select(DeviceStoreSelectors.selectCurrentLocationFrontDeskDevices));
    case LocationSubset.Bar:
      return deviceStore.pipe(select(DeviceStoreSelectors.selectCurrentLocationBarDevices));
  }
}
